export const MAX_LENGTH_MESSAGE = 255;
export const PERMITTED_CHAT_COLORS = [
    '#8F73FF',
    '#EB73FF',
    '#FF738C',
    '#FF5050',
    '#FF8C5B',
    '#FFE973',
    '#6BFF53',
    '#48FFC8',
    '#58AFFF',
    '#5667FF',
];
